import type { InsightNotificationLink } from './notificationTypes';

/**
 * Maps a notification link payload to an app route (AC-026/AC-027 cross-links).
 * canvas_screen carries a focusScreen query param the V2 canvas uses to center
 * and highlight the affected screen node.
 */
export function resolveNotificationLink(projectId: string, link: InsightNotificationLink): string | null {
  switch (link.type) {
    case 'canvas_screen': {
      if (!link.onboardingId) return null;
      const params = new URLSearchParams();
      if (link.screenId) params.set('focusScreen', link.screenId);
      const query = params.toString();
      return `/project/${projectId}/onboarding-v2/${link.onboardingId}${query ? `?${query}` : ''}`;
    }
    case 'placement_variant':
      return `/project/${projectId}/web-placements${link.placementId ? `?placementId=${encodeURIComponent(link.placementId)}` : ''}`;
    case 'experiment':
      return `/project/${projectId}/experiments`;
    case 'report':
      return `/project/${projectId}/reports`;
    default:
      return null;
  }
}
